import { Provider } from "@angular/core";
import { CampoProcesador } from "./implementaciones/CampoProcesador";
import { ErrorServidorProcesador } from "./implementaciones/ErrorServidorProcesador";
import { NonFieldProcesador } from "./implementaciones/NonFieldProcesador";
import { TimeoutProcesador } from "./implementaciones/TimeoutProcesador";
import { ListaMensajeProcesadorToken } from "./ListaMensajeProcesadorToken";

export const providersMensajeProcesador: Provider[] = [
    { provide: ListaMensajeProcesadorToken, useClass: CampoProcesador, multi: true },
    { provide: ListaMensajeProcesadorToken, useClass: ErrorServidorProcesador, multi: true },
    { provide: ListaMensajeProcesadorToken, useClass: NonFieldProcesador, multi: true },
    { provide: ListaMensajeProcesadorToken, useClass: TimeoutProcesador, multi: true }
];
